<template>
    <div class="linkBtn">
        <span>{{ props.title }}</span>
    </div>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
    title: String
});
</script>

<style lang="scss" scoped>
@import '@/styles/linkBtn';
</style>
